import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { GuidesIndex } from "./guides.index";
import { listPosts } from "../lib/api/lidoo.functions";
import { DICTS, LOCALIZED_LANGS, type Lang } from "../lib/i18n";
import { hreflangLinks } from "../lib/seo";

export const Route = createFileRoute("/$locale/guides/")({
  beforeLoad: ({ params }) => {
    if (params.locale === "en") throw redirect({ to: "/guides" });
    if (!LOCALIZED_LANGS.includes(params.locale as Lang)) throw notFound();
  },
  loader: async ({ params }) => await listPosts({ data: { lang: params.locale as Lang } }),
  head: (ctx) => {
    const d = DICTS[ctx.params.locale as Lang];
    return {
      meta: [
        { title: `${d.guides_title} | sunbedly` },
        { name: "description", content: d.guides_sub },
      ],
      links: hreflangLinks("/guides", ctx.params.locale),
    };
  },
  component: () => <GuidesIndex posts={Route.useLoaderData().posts} />,
});
